import { render } from "./TransportAndEconomy.vue?vue&type=template&id=67b77469&scoped=true"
import script from "./TransportAndEconomy.vue?vue&type=script&lang=js"
export * from "./TransportAndEconomy.vue?vue&type=script&lang=js"

import "./TransportAndEconomy.vue?vue&type=style&index=0&id=67b77469&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b77469"]])

export default __exports__